import { useMemo } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';

export const usePageCustomizable = (id) => {
  const { currentNetwork } = useDefaultAppContexts();

  const { app_pages: pages = [] } = currentNetwork;

  return useMemo(
    () => pages?.find(({ menu }) => menu.identifier === id) || {},
    [id, pages],
  );
};
